import type { Metric } from "web-vitals";

export type ClientEvent = {
    name: string;
    level?: "info" | "warning" | "error";
    data?: Record<string, unknown>;
};

const TELEMETRY_ENDPOINT = String(process.env.REACT_APP_TELEMETRY_ENDPOINT || "").trim();
const RELEASE = String(process.env.REACT_APP_RELEASE_SHA || "development").trim();
const ENVIRONMENT = String(process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || "development").trim();

export function recordClientEvent(event: ClientEvent): void {
    if (!TELEMETRY_ENDPOINT) return;
    const payload = JSON.stringify({
        ...event,
        release: RELEASE,
        environment: ENVIRONMENT,
        path: window.location.pathname,
        occurredAt: new Date().toISOString(),
    });
    try {
        if (navigator.sendBeacon?.(TELEMETRY_ENDPOINT, new Blob([payload], { type: "application/json" }))) return;
        void fetch(TELEMETRY_ENDPOINT, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: payload,
            keepalive: true,
        });
    } catch {
        // Telemetry must never interrupt the product path.
    }
}

export function reportClientError(error: Error, componentStack = ""): void {
    recordClientEvent({
        name: "client_error",
        level: "error",
        data: { message: error.message, stack: error.stack || "", componentStack },
    });
}

export function reportWebVital(metric: Metric): void {
    recordClientEvent({
        name: "web_vital",
        level: "info",
        data: { metric: metric.name, value: metric.value, delta: metric.delta, id: metric.id },
    });
}
